<template>
  <el-container>
    <div class="Nav-hader" style="height:none">
     <img v-show="id==0" style="width:100%;" src="../assets/img/1.png" alt="">
     <img v-show="id==1" style="width:100%;" src="../assets/img/2.1.png" alt="">
     <img v-show="id==2" style="width:100%;" src="../assets/img/3.png" alt="">
     <img v-show="id==3" style="width:100%;" src="../assets/img/4-2.png" alt="">
     <img v-show="id==4" style="width:100%;" src="../assets/img/5.png" alt="">
     <img v-show="id==5" style="width:100%;" src="../assets/img/6.png" alt="">
      <el-row :gutter="2" style=" width:100%; position: absolute;top: 0px;left: 0;">
        <el-col :sm="5"
                :xs="24">
          <div class="grid-content bg-purple cs">
            <i class="header-logo">
              <img src="../assets/logo.png"  alt="">
            </i>
          </div>
        </el-col>
        <el-col :span="17" :offset="3"
                class="header-left">
          <div class="grid-content "
               :style="{background:(!flag?'#fff':'none')}">

            <i :class="flag ? 'el-icon-menu' : 'el-icon-close'"
               class="el-cin"
               @click="clickIcon"></i>


            <ul class="header-nav bg-purple-light"
                :class="flag ? 'shouFlag' : ''">
                <li>
                  <i class="header-logo">
              <img style="margin-right:50px;" src="../assets/logo.png"  @click="toHome()" alt="">
            </i>
                </li>
              <li v-for="(item,index) in lis" :key="index" @click="liclick(item)"
              :class="id==0&&id==item.id?'active0':
              id==1&&id==item.id?'active1':
              id==2&&id==item.id?'active2':
              id==3&&id==item.id?'active3':
              id==4&&id==item.id?'active4':
              id==5&&id==item.id?'active5':
              id==6&&id==item.id?'active6':
              id==7&&id==item.id?'active7':''
              ">
              <router-link class="series-slide-trigger"
              :to="item.to">{{item.text}}</router-link>
              </li>
              <li>
                <span class="series-slide-trigger" @click="sendphone('010-62488895')">010-62488895</span>
                <!-- <span class="series-slide-trigger" @click="send()">登录</span> -->
              </li>
            </ul>

          </div>
        </el-col>
      </el-row>

      <div class="Nav-hader-text" v-if="id==0">
      <p>把最好的服务献给星空</p>
      <p>用最好的产品报效祖国</p>
      <p>—————技术引领世界 创新照耀未来</p>
      <!-- <p><span style="cursor: pointer;" @click="clickspan(1)">联系我们</span></p> -->
    </div>

    <div class="Nav-hader-text" style="text-align:left" v-if="id==1">
      <p>产品服务</p>
      <p></p>
      <p>我们与众不同<br> 国内首家也是唯一建设天地一体化测控运营服务体系</p>
      <!-- <p><span style="cursor: pointer;" @click="clickspan(1)">联系我们</span></p> -->
    </div>

    <div class="Nav-hader-text" style="text-align:left" v-if="id==2">
      <p>解决方案</p>
      <p></p>
      <p>巍巍昆仑 闪耀星空</p>
      <!-- <p><span style="cursor: pointer;" @click="clickspan(1)">联系我们</span></p> -->

    </div>
    <div class="Nav-hader-text" style="text-align:left" v-if="id==3">
      <p>新闻动态</p>
      <p></p>
      <p>同心同德 勇毅前行</p>
      <!-- <p><span style="cursor: pointer;" @click="clickspan(1)">联系我们</span></p> -->
    </div>




    </div>

  </el-container>
</template>

<script>
export default {
  data () {
    return {
      flag: true,
      flag1: true,
      ss: false,
      lis:[
        {to:'/',text:'首页',id:0},
        {to:'/product',text:'产品及服务',id:1},
        {to:'/solution',text:'解决方案',id:2},
        {to:'/news',text:'新闻动态',id:3},
        {to:'/about',text:'关于我们',id:4},
        {to:'/contact',text:'联系我们',id:5},
        // {to:'/',text:'010-62488895',id:6},
        // {to:'/',text:'登录',id:7},
      ],
      id:9,
    };
  },
  watch: {
    // 监测路由对象中的$route属性
    '$route': {
      handler: function (to, from) {
        // 路由发生变化时执行的代码
        console.log('Route changed from', from.path, 'to', to.path);
        if(this.$route.path=='/new'){
      this.id='3'
     }else if(this.$route.path=='/productDetail'){
         this.id='1'
     }else if(this.$route.path=='/product'){
         return
     }else if(this.$route.path=='/solution'){
         return
     }  else{
      var ss=this.lis.filter(res=>{
            return res.to == to.path
        })
          this.id=ss[0].id
          console.log(this.id)
     }


        // 这里可以根据路由变化执行相应的逻辑
      },
      // 设置为深度监测
      deep: true
    },
  },
  created(){
     var that=this
     if(that.$route.path=='/new'){
      this.id='3'
     }else if(this.$route.path=='/productDetail'){
         this.id='1'
     }else{
      var ss=this.lis.filter(res=>{
         return res.to == that.$route.path
     })
     that.id=ss[0].id

     }
      console.log(this.id)

  },
  methods: {
    toHome(){
      this.$router.push({path:'/'})
    },
    clickIcon () {
      this.flag = !this.flag;
    },
    clickIcon1 () {
      this.flag1 = !this.flag1;
    },
    liclick(item){
      this.id=item.id
    },
    sendphone(phone){
      window.location.href='tel:'+phone
    },
    clickspan(index){
      if(index==1){
        this.id=5
        this.$router.push({path:'/contact',query:{id:1}})
      }
    },
    send(){
      window.open('http://172.16.7.2/');
    },
  }
};
</script>

<style lang="scss" scoped>
.Nav-hader {
  width:100%;
  overflow: hidden;
  position: relative;
  text-align: center;
  // background-color: #0152a1;
  color:white;
  background-size: contain;
}
.Nav-hader1{
 background: url('../assets/img/2.1.png') no-repeat;
}
.Nav-hader2{
 background: url('../assets/img/3.png') no-repeat;
}
.Nav-hader3{
 background: url('../assets/img/4-2.png') no-repeat;
}
.Nav-hader4{
 background: url('../assets/img/5.png') no-repeat;
}
.Nav-hader5{
 background: url('../assets/img/6.png') no-repeat;
}
.header-logo {
  font-size: 40px;
  color: #eb0028;
}
.active0{
  background-image: linear-gradient(#00529f, transparent);
}
.active1{
  background-image: linear-gradient(#9a2b32, transparent);
}
.active2{
  background-image: linear-gradient(#c3a83d, transparent);
}
.active3{
  background-image: linear-gradient(#05488e, transparent);
}
.active4{
  background-image: linear-gradient(#5a8011, transparent);
}
.active5{
  background-image: linear-gradient(#b58813, transparent);
}
.active6{
  background-image: linear-gradient(#00529f, transparent);
}
.active7{
  background-image: linear-gradient(#00529f, transparent);
}

.header-nav {
  li,
  a {
    font-size: 14px;
    display: inline-block;
    vertical-align: top;
    line-height: 60px;
    height: 60px;
    min-width: 60px;
    margin-right: -1px;
    cursor: pointer;
    box-sizing: border-box;
  }
  li {
    &:hover .header-nav-box {
      display: block;
    }
  }
  .series-slide-trigger {
    padding: 0 20px;
    color: white;
  }
}
.el-cin {
  display: none;
  color: white;
  transition: 1s;
}
.icoffo {
  display: none;
  color: #333;
  transition: 1s;
}
.cs{
  display: none;
}
.bg-purple {
  height: 60px;
  line-height: 60px;
  font-size: 25px;
  cursor: pointer;
  color: #333;
}
.Nav-hader-text{
  // width:25%;
  text-align: right;
  position: absolute;
  top:25%;
  left:16%;
  color:white;
  p{
    margin-bottom:10px;
    font-size: 36px;
  }
  p:nth-child(3){
    font-size:20px;
  }
  p:nth-child(4){
    span{
      padding:10px;
      font-size:16px;
      border:1px solid white;
    }
  }
}
// 响应式
@media only screen and (max-width: 767px) {
  .Nav-hader .grid-content .shouFlag {
    display: none !important;
  }
  .cs{
  display: none;
}
  .Nav-hader{
    height:200px !important;
  }
  .shouFlag {
    display: none !important;
  }
  .Nav-hader-text p{
    display: none;
  }
  .header-right {
    display: block;
    position: absolute;
    right: 40px;
  }
  .header-left {
    display: block;
  }
  .bg-purple-light {
    background: #fff;
    float: 1;
    height: 100%;
    position: fixed;
    top: 60px;
    left:0;
    z-index: 10;
    width: 100%;
  }
  .el-cin {
    display: block;
    font-size: 25px;
    position: absolute;
    top: 20px;
    left: 15px;
  }
  .icoffo {
    display: inline-block;
    position: absolute;
    right: 30px;
    top: 20px;
    font-size: 25px;
  }
  .bg-purple-light li {
    display: block;
    height: auto;
    padding: 0 30px;
  }
  .header-nav .series-slide-trigger {
    border-bottom: 1px solid #333;
    color: #000;
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    font-size: 18px;
  }
  .header-nav > li {
    position: relative;
  }
  .header-nav-box {
    position: relative;
  }
}
</style>
